module.exports = __webpack_public_path__ + "static/media/diamonds-are-forever-3-lines.51650e3a.gif";